import { DtoBase } from 'UvExplorerServer.Dtos.TS';
import { GroupDto } from 'UvExplorerServer.Dtos.TS/Auth';
import { List } from "DiscoveryEngine.TS/Utils";
import { ObjSerUtils } from "DiscoveryEngine.TS/Serialization";


export class GroupTreeDto extends DtoBase {

	public Groups: List<GroupDto>;

	constructor() {
		super();

		this.Groups = new List<GroupDto>();
	}

	public Clear(): void {
		this.Groups.Clear();
	}

	public get HasGroups(): boolean {
		return (!!this.Groups && this.Groups.Count > 0);
	}

	public AddGroup(value: GroupDto): void {
		this.Groups.Add(value);
	}

	public RemoveGroup(guid: string): void {
		let group = this.FindGroupByGuid(guid);
		if (group) {
			this.Groups.Remove(group);
		}
	}

	public FindGroupByGuid(guid: string): GroupDto {
		for (let i: number = 0; i < this.Groups.Count; ++i) {
			if (this.Groups.Get(i).Guid === guid)
				return this.Groups.Get(i);
		}
		return null;
	}

	public FindGroupParent(guid: string): GroupDto {
		for (let i: number = 0; i < this.Groups.Count; ++i) {
			let group = this.Groups.Get(i);
			if (group.MemberGroupGuids.Contains(guid)) {
				return group;
			}
		}
		return null;
	}

	public get RootGroup(): GroupDto {
		for (let i: number = 0; i < this.Groups.Count; ++i) {
			if (!this.Groups.Get(i).Name)
				return this.Groups.Get(i);
		}
		return new GroupDto();
	}

	public Write(obj: any, context: any): void {

		obj.group_tree = {};
		obj = obj.group_tree;

		super.Write(obj, context);

		if (this.HasGroups) {
			obj.groups = [];
			ObjSerUtils.WriteObjSerCollection(obj.groups, this.Groups, context);
		}
	}

	public Read(obj: any, context: any): void {

		if (!obj.group_tree)
			throw new Error();
		obj = obj.group_tree;

		super.Read(obj, context);

		if (obj.groups !== undefined) {
			this.Groups.Clear();
			ObjSerUtils.ReadObjSerCollection(obj.groups, this.Groups,
				(value: any) => new GroupDto(), context);
		}
	}

}